import Swiper from 'swiper';
import { Scrollbar, Navigation } from 'swiper/modules';

const IngredientsSlider = {
    init() {
        const sliderContainer = document.querySelector('.js-ingredients-swiper');
        if (!sliderContainer) return;

        const prevBtn = document.querySelector('.js-ingredients-prev');
        const nextBtn = document.querySelector('.js-ingredients-next');
        const navContainer = document.querySelector('.js-ingredients-nav');
        const scrollbarContainer = document.querySelector('.js-ingredients-scrollbar-container');

        const swiper = new Swiper(sliderContainer, {
            modules: [Scrollbar, Navigation],
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetAfter: 80,
            slidesOffsetBefore: 0,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                hide: false
            },
            navigation: {
            },
            breakpoints: {
                1024: {
                    spaceBetween: 24
                }
            },
            on: {
                init: function(s) {
                    checkScrollbarVisibility(s);
                },
                resize: function(s) {
                    checkScrollbarVisibility(s);
                },
                    setTranslate: function() {
                }
            }
        });

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                swiper.slidePrev();
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                swiper.slideNext();
            });
        }

        function checkScrollbarVisibility(s) {
            if (s.isLocked) {
                 if (navContainer) navContainer.classList.add('is-hidden');
                 if (scrollbarContainer) scrollbarContainer.classList.add('is-hidden');
            } else {
                 if (navContainer) navContainer.classList.remove('is-hidden');
                 if (scrollbarContainer) scrollbarContainer.classList.remove('is-hidden');
            }
        }

        const toggleBtns = document.querySelectorAll('.ingredient-toggle-btn');
        toggleBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const card = e.currentTarget.closest('.ingredient-card');
                document.querySelectorAll('.ingredient-card').forEach(c => {
                    card !== c && c.classList.remove('is-active');
                });
                card.classList.toggle('is-active');
            });
        });
    }
};

export default IngredientsSlider;
